<template>
  <div class="hs-toolbar" :class="{ 'hs-toolbar--compact': compact }">
    <div v-if="$slots.left" class="hs-toolbar__left">
      <slot name="left" />
    </div>
    <div v-if="$slots.default" class="hs-toolbar__center">
      <slot />
    </div>
    <div v-if="$slots.right" class="hs-toolbar__right">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: "HsToolbar",
  props: {
    compact: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.hs-toolbar {
  align-items: center;
  background: color-mix(in srgb, var(--hs-surface, #fff) 92%, transparent);
  border: 1px solid var(--hs-border, rgba(148, 163, 184, 0.22));
  border-radius: 20px;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.06);
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 0.85rem;
}

.hs-toolbar--compact {
  border-radius: 16px;
  padding: 0.55rem;
}

.hs-toolbar__left,
.hs-toolbar__center,
.hs-toolbar__right {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  min-width: 0;
}

.hs-toolbar__center {
  flex: 1;
}

.hs-toolbar__right {
  justify-content: flex-end;
}

@media (max-width: 1023px) {
  .hs-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .hs-toolbar__left,
  .hs-toolbar__center,
  .hs-toolbar__right {
    width: 100%;
  }
}
</style>
